import React, { Component } from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import '../css/style.css';
import Iframe from 'react-iframe';



class Contact extends Component {
  
    render() {
      return (
      <div className="project-bg">
       <Container >
            <Row className="vcenter" >
              <Col xs={12} className="mx-auto">
                <Iframe url="https://maitaiverse.com/form/0bb000d6-a66b-44e6-a151-3285e63daadd"
                  width="100%"
                  height="800px"
                  id="n8n-form"
                  className="contactFrame"
                  display="initial"
                  position="relative"
                  title="Contact form"
                />
              </Col>
            </Row>
    </Container>
    </div>
      )
    }
  }
  
  export default Contact;